module.exports = __webpack_public_path__ + "static/img/qr-app.8eebabd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-app.gif
// module id = 146
// module chunks = 1 6